import React from 'react';
import PropTypes from 'prop-types';

import styles from './Stylesheet.module.css';

const ButtonWithPrice = ({text, price, disabled=false, handleClick}) => {
  const buttonStyle = disabled ? `${styles.button} ${styles.disabledButton}` : styles.button;
  /* ignore click function if disabled */
  const buttonClick = disabled ? event => event.preventDefault() : handleClick;

  return (
    <button 
      className={`${buttonStyle} ${styles.priceButton}`}
      onClick={buttonClick}
    >
      <span className={styles.buttonText}>{text}</span>
      <span className={styles.buttonPrice}>${price}</span>
    </button>
  );
};

ButtonWithPrice.propTypes = {
  text: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  disabled: PropTypes.bool,  
  handleClick: PropTypes.func
}

export default ButtonWithPrice;